import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const archiveRuleSet = api(async function archiveRuleSet({ id }) {
    return mutate(
        gql`
            mutation ArchiveRuleSet($id: String!) {
                archiveRuleSet(id: $id)
            }
        `,
        { id },
        { returns: "archiveRuleSet" }
    )
})
